export function transformMessages(data, setMessages) {
    const messages = [];

    data.sort((a, b) => new Date(a.created) - new Date(b.created));

    data.forEach(item => {
        const isFromMe = !!item.response && !item.original_messages;
        const jsonString = item.response || item.original_messages;
        const createdMessage = item.created;
        if (!jsonString) return;
        try {
            const parsed = JSON.parse(jsonString);
            const entries = parsed.entry || [];
            const isTemplate = item.type_message === 'template';
            const timestamp = new Date(createdMessage);
            const time = timestamp.toLocaleTimeString('es-CO', {
                hour: '2-digit',
                minute: '2-digit',
            });
            if (isTemplate) {
                messages.push({
                    fromMe: isFromMe,
                    type: 'template',
                    date: createdMessage,
                    time,
                    text: parsed
                });

            }else{
                entries.forEach(entry => {
                    const changes = entry.changes || [];
                    changes.forEach(change => {
                        const value = change.value || {};
                        const msgs = value.messages || [];

                        msgs.forEach(msg => {
                            const commonData = {
                                fromMe: isFromMe,
                                date: createdMessage,
                                time,
                                type: msg.type
                            };

                            if (msg.type === 'text' && msg.text?.body) {
                                messages.push({
                                    ...commonData,
                                    text: msg.text.body,
                                });
                            }

                            if (msg.type === 'video' && msg.video) {
                                messages.push({
                                    ...commonData,
                                    url: msg.url_path_whatsapp, 
                                    name: msg.video.filename || 'video.mp4',
                                    mimeType: msg.video.mime_type || 'video/mp4',
                                    caption: msg.video.caption || ''
                                });
                            }

                            if (msg.type === 'document' && msg.document) {
                                messages.push({
                                    ...commonData,
                                    url: msg.url_path_whatsapp,
                                    name: msg.document.filename || 'document',
                                    mimeType: msg.document.mime_type || '',
                                });
                            }

                            if (msg.type === 'image' && msg.image) {
                                messages.push({
                                    ...commonData,
                                    url: msg.url_path_whatsapp,
                                    name: msg.image.filename || 'image.jpg',
                                    caption: msg.image.caption || '',
                                    mimeType: msg.image.mime_type || 'image/jpeg',
                                });
                            }

                            if (msg.type === 'audio' && msg.audio) {
                                messages.push({
                                    ...commonData,
                                    url: msg.url_path_whatsapp,
                                    name: 'audio.m4a',
                                    mimeType: msg.audio.mime_type || 'audio/ogg',
                                });
                            }

                            if(msg.type === 'sticker' && msg.sticker){
                                messages.push({
                                    ...commonData,
                                    url: msg.url_path_whatsapp,
                                    name: msg.sticker.filename,
                                    caption: msg.sticker.caption || '',
                                    animated: msg.animated || false,
                                    mimeType: msg.sticker.mime_type
                                });
                            }
                        });
                    });
                });
            }
            
        } catch (err) {
            console.error('Error parsing JSON:', err);
        }
    });
    setMessages(messages);
}

export const parseComponents = (componentsString) => {
    try {
        const components = JSON.parse(componentsString);
        const result = {};

        for (const comp of components) {
            switch (comp.type) {
            case 'HEADER':
                result.header = comp.text || '';
                break;
            case 'BODY':
                result.body = comp.text || '';
                break;
            case 'FOOTER':
                result.footer = comp.text || '';
                break;
            case 'BUTTONS':
                result.buttons = comp.buttons || [];
                break;
            default:
                break;
            }
        }
      return result;
    } catch  (err) {
        console.error('Error parsing components:', err);
        return {
            header: '',
            body: '',
            footer: '',
            buttons: []
        };
    }
};

export const replaceTemplateVariables = (template, values = []) => {
  return template.replace(/{{(\d+)}}/g, (_, index) => {
    const i = parseInt(index, 10) - 1;
    return values[i] !== undefined ? values[i] : '';
  });
};

export const buildTemplateComponents = (vars, selectedTemplate) => {
        const components = [];
        for (const section of ['header', 'body', 'footer']) {
            if (vars[section]?.length > 0) {
                components.push({
                    type: section,
                    parameters: vars[section].map((text) => ({ type: 'text', text }))
                });
            }
        }

        const { buttons } = parseComponents(selectedTemplate?.components || []);
        if (buttons && buttons.length > 0) {
            let hasUrlButton = false;
            const buttonsComponent = {
                type: 'BUTTONS',
                buttons: []
            };
            buttons.forEach((btn, idx) => {
                const buttonVars = vars.buttons?.[idx] || [];
                if (btn.type === 'URL' && /\{\{\d+\}\}/.test(btn.url)) {
                    hasUrlButton = true
                    buttonsComponent.buttons.push({
                        type: btn.type,
                        text: btn.text,
                        url: btn.url,
                        parameters: buttonVars.map((text) => ({ type: 'text', text }))
                    });
                }
            });
            if (hasUrlButton){
                components.push(buttonsComponent);
            }
        }

        return components;
};